import { render, staticRenderFns } from "./EditExperiment.vue?vue&type=template&id=fb849f7a&"
import script from "./EditExperiment.vue?vue&type=script&lang=js&"
export * from "./EditExperiment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports